import { publicApi } from "@/shared/api/api";
import { CONTACT_API_PATHS } from "../constants/apiConstants";

export interface ContactFormPayload {
  full_name: string;
  email: string;
  phone?: string;
  subject?: string;
  message: string;
}

export interface ContactFormResponse {
  message: string;
}

export const sendContactMessage = async (
  payload: ContactFormPayload
): Promise<ContactFormResponse> => {
  return publicApi.post<ContactFormResponse>(
    CONTACT_API_PATHS.SEND_MESSAGE,
    payload
  );
};
